import React, { Fragment, useMemo, useState } from 'react';
import { When } from 'UI/components/atoms';
import { PreviewMetaRowsSections } from 'UI/components/molecules/PreviewBulkEmail/components/PreviewMetaRowsSections';
import BulkStatsDrawer from 'UI/components/organisms/BulkStatsDrawer';

import { INITIAL_BULK_KEY } from '../BulkEmailDrawerAttempts/BulkEmailDrawerAttempts.constants';
import { BulkEmailEditAttemptDrawer } from '../BulkEmailEditAttemptDrawer';

import { BulkEmailSequencesPreviewItem } from './BulkEmailSequencesPreviewItem';

export const BulkEmailSequencesPreview = ({
  initialBulkConfig,
  initialBulkMetaRows,
  sequencesMeta
}) => {
  const [uiState, setUiState] = useState({
    editAttemptDrawer: {
      open: false,
      id: null,
      number: null
    },
    statsDrawerId: null
  });

  const sectionsMetaRows = useMemo(
    () =>
      sequencesMeta
        ? [
            {
              key: INITIAL_BULK_KEY,
              bulkId: initialBulkConfig.id,
              metaRows: initialBulkMetaRows,
              shouldEnableMenuButton: false,
              shouldEnableStatsButton: true
            },
            ...sequencesMeta.map(attempt => ({
              key: attempt.key,
              bulkId: attempt.bulkId,
              metaRows: (
                <PreviewMetaRowsSections
                  firstSectionData={attempt.meta}
                  subject={attempt.subject}
                  emailBody={attempt.html}
                />
              ),
              shouldEnableMenuButton: attempt.shouldEnableMenuButton,
              shouldEnableStatsButton: attempt.shouldEnableStatsButton
            }))
          ]
        : null,
    [initialBulkConfig.id, initialBulkMetaRows, sequencesMeta]
  );

  const togglers = {
    editAttemptDrawer:
      ({ id, number, open }) =>
      () =>
        setUiState(prev => ({ ...prev, editAttemptDrawer: { id, number, open } })),
    statsDrawer:
      ({ id }) =>
      () =>
        setUiState(prev => ({ ...prev, statsDrawerId: id }))
  };

  return (
    <>
      {sectionsMetaRows.map((section, index) => (
        <BulkEmailSequencesPreviewItem
          key={section.key}
          isLastElement={index < sectionsMetaRows.length - 1}
          onOpenEditStepDrawer={togglers.editAttemptDrawer({
            id: section.bulkId,
            number: index + 1,
            open: true
          })}
          onOpenStatsDrawer={togglers.statsDrawer({ id: section.bulkId })}
          sectionKey={section.key}
          shouldEnableMenuButton={section.shouldEnableMenuButton}
          shouldEnableStatsButton={section.shouldEnableStatsButton}
        >
          {section.metaRows}
        </BulkEmailSequencesPreviewItem>
      ))}
      <When condition={uiState.statsDrawerId}>
        <BulkStatsDrawer
          bulkId={uiState.statsDrawerId}
          bulkTypeId={initialBulkConfig.typeId}
          onClose={togglers.statsDrawer({ id: null })}
          userEmail={initialBulkConfig.userEmail}
        />
      </When>
      <When condition={uiState.editAttemptDrawer.open}>
        <BulkEmailEditAttemptDrawer
          attemptId={uiState.editAttemptDrawer.id}
          attemptNumber={uiState.editAttemptDrawer.number}
          onClose={togglers.editAttemptDrawer({ id: null, number: null, open: false })}
        />
      </When>
    </>
  );
};
